<template>
  <section>
    <div class="lm-header">
      <h2
        class="title is-5"
        v-text="$t('Orders.title').toUpperCase()"
      />
      <h3
        class="subtitle is-5"
        v-text="$t('Common.filters')"
      />
    </div>
    <order-filters />
    <orders />
  </section>
</template>

<script>
import OrderFilters from '@/components/filters/OrderFilters'
import Orders from '@/components/dashboard/Orders'

export default {
  name: 'DashboardOrders',
  beforeCreate () {
    this.$store.dispatch('orders/flush')
    this.$store.dispatch('filters/flush')
  },
  components: {
    OrderFilters,
    Orders
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardOrders.vue